module.exports = __webpack_public_path__ + "img/funda_loan.ac942818.png";